import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { TsRestClient } from '@eluve/api-client-provider';
import { Logger } from '@eluve/logger';

import { TaskHandlerRegistry } from '../types';

import { addAppointmentTagHandler } from './addAppointmentTagHandler';
import {
  LoadManifestFiles,
  RequestFileSync,
  generateNoteHandler,
} from './generateNoteHandler';
import { markChunkFinalHandler } from './markChunkFinalHandler';
import { markClientAudioCompletedAtHandler } from './markClientAudioCompletedAtHandler';
import { prepareAudioRecordsHandler } from './prepareAudioRecordsHandler';
import { resolveEmptySegmentHandler } from './resolveEmptySegmentHandler';
import { updateSegmentHandler } from './updateSegmentHandler';

export const createTaskHandlers = ({
  apolloClient,
  apiClient,
  logger,
  loadManifestFiles,
  requestFileSync,
}: {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  apiClient: TsRestClient;
  logger: Logger;
  loadManifestFiles?: LoadManifestFiles;
  requestFileSync?: RequestFileSync;
}): TaskHandlerRegistry => {
  return {
    'TASK.GENERATE_NOTE': generateNoteHandler({
      client: apolloClient,
      apiClient,
      logger,
      loadManifestFiles,
      requestFileSync,
    }),
    'TASK.MARK_CHUNK_FINAL': markChunkFinalHandler({
      client: apiClient,
      logger,
    }),
    'TASK.PREPARE_AUDIO_RECORDS': prepareAudioRecordsHandler({
      client: apiClient,
      logger,
    }),
    'TASK.UPDATE_SEGMENT_RECORDING_ENDED_AT': updateSegmentHandler({
      client: apolloClient,
      logger,
    }),
    'TASK.MARK_CLIENT_AUDIO_COMPLETED_AT': markClientAudioCompletedAtHandler({
      logger,
      apolloClient,
    }),
    'TASK.RESOLVE_EMPTY_SEGMENT': resolveEmptySegmentHandler({
      client: apiClient,
      logger,
    }),
    'TASK.ADD_APPOINTMENT_TAG': addAppointmentTagHandler({
      client: apiClient,
      logger,
    }),
  };
};
